import React from 'react';
import { Tag, Tooltip } from 'antd';
import {
  EditOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';

interface PageVersionStatusProps {
  status: 'finalized' | 'draft' | 'processing' | string;
}

const PageVersionStatus: React.FC<PageVersionStatusProps> = ({ status }) => {
  const tagColor =
    status === 'finalized'
      ? 'success'
      : status === 'draft'
        ? 'processing'
        : 'warning';

  const tagIcon =
    status === 'finalized' ? (
      <CheckCircleOutlined />
    ) : status === 'draft' ? (
      <EditOutlined />
    ) : (
      <ClockCircleOutlined />
    );

  const tooltip =
    status === 'draft'
      ? 'In draft state, you can edit pages of pageversion.'
      : status === 'draft'
        ? 'In finalized approval state, editing pages is disabled.'
        : 'In pending state, editing pages of pageversion is disabled.';

  return (
    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Tooltip title={tooltip} color="purple">
        <Tag
          bordered
          color={tagColor}
          icon={tagIcon}
          style={{ marginLeft: '2px' }}
        >
          {status}
        </Tag>
      </Tooltip>
    </span>
  );
};

export default PageVersionStatus;